.link {
  display: flex;
  gap: 8px;
  align-items: center;
}

.link:hover {
  color: #000;
  text-decoration: underline;
}

.icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
}

.lable {
  font-size: 13px;
  font-weight: 400;
  color: rgb(0 0 0 / 60%);
}
